module.exports = __webpack_public_path__ + "static/media/delete-trashcan.e95f3158.svg";